import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "DISBURSEMENT"
export const disbursementConstants = createCRUDConstants(nameSpace);

export const name_space = "DISBURSEMENT-DROPDOWN"
export const disbursementDropdownConstants = createCRUDConstants(name_space);
